import { Fragment, useState, useEffect, useRef } from "react";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import SDK from "../config";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import SubscriptionService from "../services/subscriptionService";
import Loader from "../Components/Loader/loader";
import "react-toastify/dist/ReactToastify.css";
import TrackingScripts from "../Components/checkoutPageComponent/trackingComponent";
import postVisitorsData from "../Components/web/visitors";
import Header from "../Components/ui/header";
import { images } from "../Constants/imageslinks";
import AddictiveAppCards from "../Components/LaunchePageComponents/addictiveAppCards";
import NewportSection from "../Components/LaunchePageComponents/newportSection";
import TimeLimitCards from "../Components/LaunchePageComponents/timeLimitCards";
import WelcomeScreenCards from "../Components/LaunchePageComponents/welcomeScreenCards";
import AndroidSection from "../Components/LaunchePageComponents/androidSection";
import Footer from "../Components/ui/footer";

const LauncherPage = () => {
  const { region } = useParams();
  const [searchParams] = useSearchParams();
  const [currRegion, setCurrRegion] = useState("");
  const [pageLoader, setPageLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 500);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const navigate = useNavigate();
  const eventId = `event-${new Date().getTime()}`;
  const videoRef = useRef(null);
  const BASE_URL = SDK.getBaseUrl("");

  const referralCode = searchParams.get("referralCode");

  useEffect(() => {
    if (region === "uk" || region === "eu") {
      localStorage.setItem("region", region);
      setCurrRegion(`${region}`);
    } else {
      localStorage.setItem("region", "us");
      setCurrRegion("");
    }
  }, [region]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 500);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const earlyAccessClick = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      toast.error("Please enter an email.");
      return;
    } else if (!emailRegex.test(email)) {
      toast.error("Email not valid");
      return;
    }
    setPageLoader(true);
    const response = await SubscriptionService.checkSubscriptionStatus(email);
    if (response) {
      toast.error(
        "This email has an active subscription. Please change the email address."
      );

      setPageLoader(false);
    } else {
      setPageLoader(false);
      const tagsString = "";
      const type = SDK.PAGE_TYPE;
      const queryParams = new URLSearchParams({
        email_address: email,
        status: "subscribed",
        tags: tagsString,
        AddToCart: "1",
        type,
      });
      const queryString = queryParams.toString();
      axios
        .post(`${BASE_URL}/api/post_email_smashsend?${queryString}`)
        .catch((error) => {
          console.error("Error saving email:", error);
        });
      const verifyEmail = await SubscriptionService.verfiyEmail(
        email,
        referralCode
      );
      if (verifyEmail === "pending") {
        navigate(
          `/reservation?email=${encodeURIComponent(
            email
          )}&referralCode=${referralCode}`
        );
      } else {
        navigate(
          `/payment-plan?email=${encodeURIComponent(
            email
          )}&referralCode=${referralCode}`
        );
      }
    }
  };

  const handleVideoClick = () => {
    const video = videoRef.current;
    if (video.paused) {
      video.play();
      setIsVideoPlaying(true);
    } else {
      video.pause();
      setIsVideoPlaying(false);
    }
  };

  useEffect(() => {
    let observer = null;
    let scrollTimer = null;
    let hasActivatedObserver = false;

    const activateObserver = () => {
      if (hasActivatedObserver) return;
      hasActivatedObserver = true;

      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.6,
      };

      observer = new IntersectionObserver((entries) => {
        const [entry] = entries;
        const video = videoRef.current;

        if (video) {
          if (entry.isIntersecting) {
            video
              .play()
              .then(() => setIsVideoPlaying(true))
              .catch(() => {});
          } else {
            video.pause();
            setIsVideoPlaying(false);
          }
        }
      }, observerOptions);

      if (videoRef.current) {
        observer.observe(videoRef.current);
      }
    };

    const onScroll = () => {
      if (scrollTimer) return;

      scrollTimer = setTimeout(() => {
        activateObserver();
      }, 3000);
    };

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (observer && videoRef.current) {
        // eslint-disable-next-line
        observer.unobserve(videoRef.current);
      }
      clearTimeout(scrollTimer);
    };
  }, []);

  return (
    <Fragment>
      <Loader pageLoader={pageLoader} style={{ width: "100vw" }} />
      <Toaster />
      <TrackingScripts />

      <div>
        <Header />

        <div className="bg-primary100">
          <div className="3xl:container 3xl:mx-auto">
            <div className="xl:pl-[168px] lg:pl-[108px] pl-4 xl:pr-[80px] lg:pr-[45px] pr-4 pt-[10px] pb-10 flex lg:flex-row flex-col-reverse justify-between lg:items-start items-center lg:max-h-[523px]">
              <div className="flex flex-col items-start md:px-4 lg:pl-14 xl:pl-0 sm:gap-[72px] gap-10 lg:py-[83px] w-full lg:w-auto">
                <div className="flex flex-col sm:gap-8 gap-3">
                  <div className="font-light sm:text-4xl text-xl sm:leading-[48px] leading-[30px] text-secondary100">
                    <p>Welcome Friend!</p>
                  </div>
                  <div className="font-light sm:text-base text-sm sm:leading-[25px] leading-[21px] text-secondary100 lg:max-w-[36vw] flex flex-col gap-6">
                    <p>
                      You've been gifted 30 days of Minimis Phone for iOS
                      completely free, by someone who thinks you'll love it.
                    </p>
                    <p>
                      Redeem your free month by entering your email below. Card
                      required, but you won’t be charged today.
                    </p>
                  </div>
                </div>
                <form onSubmit={earlyAccessClick} className="w-full">
                  <div className="flex gap-[7px] w-full">
                    <input
                      type="email"
                      value={email}
                      onChange={handleEmailChange}
                      className="bg-primary200 rounded-sm p-3 font-light text-lg w-full outline-none"
                      placeholder="Your email..."
                    />
                    <button className="text-primary100 bg-secondary100 rounded-sm md:py-3 py-2 xl:px-3 px-2 font-medium text-base whitespace-nowrap w-full sm:max-w-[170px] max-w-[160px] outline-none">
                      Start Free Trial
                    </button>
                  </div>
                </form>
              </div>
              <div>
                <img
                  src={images.hero_image}
                  alt="hero image"
                  className="w-full max-w-[550px] h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>

        <AddictiveAppCards />
        <NewportSection />
        <TimeLimitCards />
        <WelcomeScreenCards />

        <div className="bg-primary200">
          <div className="3xl:container 3xl:mx-auto lg:px-[3.88vw] 3xl:px-[75px] md:px-8 px-4 md:py-14 py-9 flex lg:flex-row flex-col items-center justify-between gap-6">
            <div className="flex flex-col items-center lg:items-start lg:gap-4 gap-2">
              <p className="font-light md:text-3xl text-xl leading-[100%] md:text-black text-secondary100">
                Ready to jump right in?
              </p>
              <p className="font-light md:text-base text-xs leading-[100%] md:text-black text-secondary100">
                Begin your digital minimalism journey now.
              </p>
            </div>
            <form onSubmit={earlyAccessClick} className="w-full lg:w-auto">
              <div className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  className="rounded-sm p-3 bg-primary100 font-light text-lg leading-[100%] w-full lg:min-w-[26vw] 2xl:min-w-[467px] outline-none"
                  placeholder="Your email..."
                />
                <button className="py-3 sm:px-6 px-2 bg-secondary100 rounded-sm text-primary100 font-medium text-base w-full sm:max-w-[210px] max-w-[160px] whitespace-nowrap outline-none">
                  Get 30 Day Access
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="relative w-full">
          <video
            ref={videoRef}
            src={
              isMobile
                ? "/images/launcherPageImages/minimis-launcher-mobile-video.mp4"
                : "/images/launcherPageImages/minimis-launcher-video.mp4"
            }
            type="video/mp4"
            playsInline
            muted
            autoPlay
            loop
            className="w-full h-auto"
            onClick={handleVideoClick}
          />

          {/* Overlay when video not playing */}
          {!isVideoPlaying && (
            <>
              {/* Poster Image Overlay */}
              <div
                className="absolute inset-0 bg-cover bg-center pointer-events-none"
                style={{
                  backgroundImage: `url(${
                    isMobile
                      ? images.minimisLauncherPosterMobile
                      : images.videoPosterImage
                  })`,
                }}
              ></div>

              {/* Centered Play Button */}
              <div className="absolute inset-0 flex items-center justify-center bg-[#00000080]">
                <button
                  onClick={handleVideoClick}
                  className=" flex items-center justify-center rounded-full transition"
                >
                  <img
                    src={images.videoPlayButton}
                    alt="Play Button"
                    className={`${
                      isMobile ? "w-[80px] h-[64px]" : "w-[13.88vw] h-[11.11vw]"
                    }`}
                  />
                </button>
              </div>
            </>
          )}
        </div>

        <AndroidSection />

        <Footer />
      </div>
    </Fragment>
  );
};

export default LauncherPage;
